module.exports = __webpack_public_path__ + "media/brikcombo.4af31091.mp4";